module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    staticClass: "gallery-tag-list"
  }, _vm._l((_vm.tags), function(tag) {
    return _c('li', {
      staticClass: "tag"
    }, [_c('router-link', {
      attrs: {
        "to": {
          name: 'galleries',
          query: {
            tags: '' + tag.id
          }
        }
      }
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n    ")])], 1)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-027a95b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/GalleryTagList.vue
// module id = 1962
// module chunks = 2